import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { AuthGuard } from './security/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { Error404Component } from './pages/error404/error404.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { EditUserComponent } from '../users/edit-user/edit-user.component';
import { EditUserModule } from '../users/edit-user/edit-user.module';
import { HelpFilesComponent } from '../help/help-files.component';
import { HelpVideosComponent } from '../help/help-videos/help-videos.component';
import { WebReleaseNotesComponent } from './pages/web-release-notes/web-release-notes.component';
import { SilkierHistoryComponent } from '../silkier/silkier-history/silkier-history.component';
import { HomeComponent } from './pages/home/home.component';
import { PermissionConst } from './security/generated/Permission';
import { PublicSiteDailyCountComponent } from '../core/pages/public/public-site-daily-count/public-site-daily-count.component';

// This is the root of our navigation menu route definitions
const routes: Routes = [
	{ 
		path: ''
		, component: HomeComponent
	}
    , { 
		path: 'dashboard'
		, component: DashboardComponent
		, canActivate: [ AuthGuard ] 
	}
    , { 
		path: 'login'
		, component: LoginComponent 
	}
    , { 
		path: 'release-notes'
		, component: WebReleaseNotesComponent
		, canActivate: [ AuthGuard ] 
	}
    , { 
		path: 'users/edit/details/:id'
		, component: EditUserComponent
		, canActivate: [ AuthGuard ] 
	}
    , { 
		path: 'forgot-password'
		, component: ForgotPasswordComponent 
	}
    , { 
		path: 'change-password/:id'
		, component: ChangePasswordComponent 
	}
    , { 
		path: 'admin/quartz/pcg-history'
		, component: SilkierHistoryComponent
		, canActivate: [ AuthGuard ]
	}
    , { 
		path: 'site-daily-count'
		, component: PublicSiteDailyCountComponent 
	}
    , {
		path: 'help'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, component: HelpFilesComponent
		, data: { security: PermissionConst.coreFeatures }
	}
    , {
		path: 'help/help-video/:id'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, component: HelpVideosComponent
		, data: { security: PermissionConst.coreFeatures }
	}
    , {
		path: 'organizations'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, loadChildren: () => import('../organizations/organization.module').then(m => m.OrganizationModule)
	}
    , {
		path: 'sites'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, loadChildren: () => import('../sites/site.module').then(m => m.SiteModule)
	}
    , {
		path: 'reports'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, loadChildren: () => import('../reports/reports.module').then(m => m.ReportsModule)
	}    
    , {
		path: 'users'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, loadChildren: () => import('../users/users.module').then(m => m.UsersModule)
	}
    , {
		path: 'admin'
		, canActivate: [ AuthGuard ]
		, canLoad: [ AuthGuard ]
		, loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule)
	}
    , {
		path: 'shared'
		, canActivate: [AuthGuard]
		, canLoad: [AuthGuard]
		, loadChildren: () => import('../shared/shared.module').then(m => m.SharedModule)
	}    
    , { 
		path: '**'
		, redirectTo: '' 
	}
];

export class CoreRouting {
	static declarations = [
		HomeComponent
		, DashboardComponent
		, LoginComponent
		, PublicSiteDailyCountComponent
		, Error404Component
		, ForgotPasswordComponent
		, ChangePasswordComponent
		, HelpFilesComponent
		, HelpVideosComponent
		, SilkierHistoryComponent
	];
	static imports = [
		RouterModule.forRoot(
            routes
            , {
		        scrollPositionRestoration: 'enabled'
			    , preloadingStrategy: QuicklinkStrategy
                , anchorScrolling: 'enabled'
		    }
        )
		, EditUserModule
	];
	static exports = [ RouterModule ];
	static providers = [ AuthGuard ];
}
